export const environment = {
        production: true,
        app_url: 'https://connect.andcode.nl/',
        api_url: 'https://connect.andcode.nl/api/',
        login_url: 'https://connect.andcode.nl/login/login',
        base_url: 'https://connect.andcode.nl/old/',
	validation: {
		tier: {
			name_required: 'Er is geen geldige naam opgegeven voor deze staffel.',
			at_least_one_rule_required: 'Een staffel moet tenminste één regel bevatten.',
			invalid_active_from: 'Eén of meerdere actief vanaf datums zijn niet geldig.',
			invalid_from: 'Eén of meerdere vanaf aantallen zijn niet geldig.',
			invalid_till: 'Eén of meerdere tot aantallen zijn niet geldig.',
			invalid_price_per_thousand: 'Eén of meerdere prijzen per 1000 zijn niet geldig.'
		},
		distributor: {
			name_required: 'Er is geen geldige naam opgegeven voor deze verspreider.',
			street_required: 'Er is geen straat opgegeven voor deze verspreider.',
			house_number_required: 'Er is geen huisnummer opgegeven voor deze verspreider.',
			postcode_required: 'Er is geen postcode opgegeven voor deze verspreider.',
			city_required: 'Er is geen plaats opgegeven voor deze verspreider.',
			phone_required: 'Er is geen telefoonnummer opgegeven voor deze verspreider.',
			sales_email_required: 'Er is geen e-mailadres voor de verkoop opgegeven voor deze verspreider.',
			sales_email_invalid: 'Het opgegeven e-mailadres (verkoop) is niet geldig.',
			delivery_email_required: 'Er is geen e-mailadres voor de bezorging opgegeven voor deze verspreider.',
			delivery_email_invalid: 'Het opgegeven e-mailadres (bezorging) is niet geldig.'
		},
		distributor_contract: {
			active_from_required: 'Er is geen geldige actief vanaf datum opgegeven.',
			active_from_invalid: 'Er is geen geldige actief vanaf datum opgegeven.',
			active_from_used: 'Er is al een contract met deze actief vanaf datum.',
			price_per_thousand_required: 'Er is geen geldige prijs per 1000 opgegeven.',
			price_per_thousand_invalid: 'Er is geen geldige prijs per 1000 opgegeven.',
			price_per_thousand_to_low: 'De prijs per 1000 mag niet negatief zijn.',
			discount_required: 'Er is geen geldige korting opgegeven.',
			discount_invalid: 'Er is geen geldige korting opgegeven.',
			discount_to_low: 'De korting mag minimaal 0 zijn.',
			discount_to_high: 'De korting mag maximaal 100 zijn.',
			uses_gross_required: 'Er is geen geldige aantallen selectie gemaakt.',
			uses_gross_invalid: 'Er is geen geldige aantallen selectie gemaakt.',
			tier_invalid: 'Er is geen geldige staffel geselecteerd.'
		},
		distributor_contract_area: {
			distributor_contract_invalid: 'Er is een fout opgetreden tijdens het opslaan van het gebied.',
			delivery_street_required: 'Er is geen geldige straat opgegeven.',
			delivery_house_number_required: 'Er is geen geldig huisnummer opgegeven.',
			delivery_postcode_required: 'Er is geen geldige postcode opgegeven.',
			delivery_city_required: 'Er is geen geldige plaats opgegeven.',
			no_postcodes: 'Een gebied moet tenminste één postcode bevatten.',
			postcode_invalid: 'Eén of meerdere postcodes zijn niet geldig.',
			postcode_used_in_other_area: 'Eén of meerdere postcodes zijn al gebruikt in andere gebieden binnen het huidige contract.',
			price_per_thousand_invalid: 'Eén of meerdere prijzen per 1000 zijn niet geldig.',
			total_amount_invalid: 'Eén of meerdere aantal (Totaal) zijn niet geldig.',
			total_amount_should_be_greater_than_gross_amount: 'Het aantal (Totaal) moet groter zijn dan het aantal (Bruto).',
			total_amount_should_be_greater_than_or_equal_gross_amount: 'Het aantal (Totaal) moet groter of gelijk zijn dan het aantal (Bruto).',
			gross_amount_invalid: 'Eén of meerdere aantal (Bruto) zijn niet geldig.',
			gross_amount_should_be_greater_than_net_amount: 'Het aantal (Bruto) moet groter zijn dan het aantal (Netto).',
			gross_amount_should_be_greater_than_or_equal_net_amount: 'Het aantal (Bruto) moet groter of gelijk zijn dan het aantal (Netto).',
			net_amount_invalid: 'Eén of meerdere aantal (Netto) zijn niet geldig.',
			not_same_walkday: 'Er mogen niet twee dezelfde loopdagen op dezelfde postcode staan.',
			removed_postalcode: 'Let op! Check ook voorkeursverspreiders.'
		},
		invoice_line: {
			invoice_id_invalid: 'Factuur niet gevonden.',
			characteristic_required: 'Er is geen kenmerk opgegeven voor deze factuurregel.',
			characteristic_character_limit_exceeded: 'Het kenmerk overschrijdt het maximale aantal karakters.',
			description_required: 'Er is geen omschrijving opgegeven voor deze factuurregel.',
			description_character_limit_exceeded: 'De omschrijving overschrijdt het maximale aantal karakters.',
			amount_required: 'Er is geen aantal opgegeven voor deze factuurregel.',
			amount_not_numeric: 'Het opgegeven aantal is niet een geldig nummer.',
			price_per_unit_required: 'Er is geen prijs per eenheid opgegeven voor deze factuurregel.',
			price_per_unit_not_numeric: 'De opgegeven prijs is niet een geldig nummer.',
			price_unit_required: 'Er is geen prijs eenheid opgegeven voor deze factuurregel.',
			price_unit_invalid: 'De opgegeven prijseenheid is niet geldig.',
			vat_type_required: 'Er is geen btw aantal opgegeven voor deze factuurregel.',
			vat_type_invalid: 'Het opgegeven btw aantal is niet geldig.'
		}
	},
	price_units: {
		price_per_thousand: 'Per 1000 stuks',
		price_per_unit: 'Per stuk'
	}
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts